export const load = () => ({
	title: 'Save up to 20% during our March Madness Sale',
	showTitle: false,
});
